<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M14,3C13.76,3,13.56,3.09,13.38,3.23C13.38,3.23,13.37,3.22,13.37,3.22C13.37,3.22,9,6.720000000000001,9,6.720000000000001C9,6.720000000000001,9,4,9,4C9,3.45,8.55,3,8,3C7.76,3,7.56,3.09,7.38,3.23C7.38,3.23,7.38,3.22,7.38,3.22C7.38,3.22,2.38,7.22,2.38,7.22C2.38,7.22,2.39,7.23,2.39,7.23C2.16,7.41,2,7.68,2,8C2,8.32,2.16,8.59,2.38,8.77C2.38,8.77,2.38,8.780000000000001,2.38,8.780000000000001C2.38,8.780000000000001,7.38,12.78,7.38,12.78C7.38,12.78,7.39,12.77,7.39,12.77C7.56,12.91,7.76,13,8,13C8.55,13,9,12.55,9,12C9,12,9,9.280000000000001,9,9.280000000000001C9,9.280000000000001,13.38,12.78,13.38,12.78C13.38,12.78,13.39,12.77,13.39,12.77C13.56,12.91,13.76,13,14,13C14.55,13,15,12.55,15,12C15,12,15,4,15,4C15,3.45,14.55,3,14,3C14,3,14,3,14,3Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'FastBackward',
} as DefineComponent
</script>
